import { Map, Record } from "immutable";

import {
  AssignmentType,
  defaultAssignmentValues
} from "seneca-common/features/assignments/state";

import Assignee from "./Assignee";
import SectionAggregation from "./SectionAggregation";
import QuestionsAggregation from "./QuestionsAggregation";

export type TeacherAssignmentType = AssignmentType & {
  assignees: Map<string, Assignee>;
  sectionAggregations?: Map<string, SectionAggregation>;
  questionAggregations?: QuestionsAggregation;
};

export const defaultTeacherAssignmentValues: TeacherAssignmentType = {
  ...defaultAssignmentValues,
  assignees: Map<string, Assignee>(),
  autoEnrolNewUsers: undefined,
  sectionAggregations: undefined,
  questionAggregations: undefined
};

export default class TeacherAssignment extends Record(
  defaultTeacherAssignmentValues
) {}
